import { createContext } from 'react';

const followUpsContext = createContext();

export default followUpsContext;
